import * as React from 'react';
import '../styles/request-details.scss';
import { Grid, Skeleton } from '@mui/material';
import moment from "moment/moment";
import xss from 'xss';
import { Box } from '@mui/system';
import { customFormatDate } from 'util/utilityMethods';
import RequestGroupDropdown from "modules/cbre-flow-lab-instruments-details/components/RequestGroupDropdown";
import { useHistory } from 'react-router';
import SystemDropdown from 'modules/cbre-flow-lab-instruments-details/components/systemDropdown';
import service from 'util/apiService';
import { getSystemDetailUrl } from '../../cbre-flow-lab-instruments-details/selectors/index';
import { getRequestbaseUrl } from '../../cbre-flow-request-info/ducks/selectors';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { DocumentsContainer } from 'modules/cbre-document-file-upload-download';
import { Link } from 'react-router-dom';
import { getInstrumentDetailUrl } from 'modules/cbre-flow-lab-instrument-asset-info/ducks/selectors';
import DescriptionIcon from '@mui/icons-material/Description';

interface RequestDetails {
  workRequestId?: any
  requestId?: any
  request_td_system?: any
  instrumentId?: any
  assetId?: any
  assetId_data?: any
  c_additionallocationdetails?: any
  c_additionalrequestoremail?: any
  c_alreadyserialnumber?: any
  c_alternativeemailone?: any
  c_arcassetdescription?: any
  c_arcassetid?: any
  c_arcassetstatus?: any
  c_arcbackuplabmanager?: any
  c_arcbudget?: any
  c_arcbuilding?: any
  c_arcbuilding_data?: any
  c_arcbuildingnewchoice?: any
  c_arccalibrationseveryxmonths?: any
  c_arccapexvalue?: any
  c_arcclientcostcenter?: any
  c_arcclientcostcenter_data?: any
  c_arcclientcriticalitylevel?: any
  c_arcclientcriticalitylevel_data?: any
  c_arcclientfinancialid?: any
  c_arccommit?: any
  c_arcdepartment?: any
  c_arcdepartment_data?: any
  c_arcendofwarrantydate?: any
  c_arcfinancialapprover?: any
  c_arcfinancialapprover_data?: any
  c_arcflag?: any
  c_arcfloorlevel?: any
  c_arcgxpstatus?: any
  c_arcgxpstatus_data?: any
  c_arcinstalldate?: any
  c_arcinstrumentowner?: any
  c_arcinstrumentowner_data?: any
  c_arclabmanager?: any
  c_arclabmanager_data?: any
  c_arclocalserviceline?: any
  c_arcmanufacturedate?: any
  c_arcmanufacturer?: any
  c_arcmanufacturer_data?: any
  c_arcnewserviceprovider?: any
  c_arcnewsystem?: any
  c_arcnextcalibrationdate?: any
  c_arcnextcertificationdate?: any
  c_arcnextqualificationdate?: any
  c_arcnextservicedate?: any
  c_arcnumberofcalibrations?: any
  c_arcnumberofcalibrations_data?: any
  c_arcnumberofpms?: any
  c_arcnumberofpms_data?: any
  c_arcnumberofqualifications?: any
  c_arcnumberofqualifications_data?: any
  c_arcnumberofrepairs?: any
  c_arcnumberofrepairs_data?: any
  c_arcpmseveryxmonths?: any
  c_arcpurchasepricecurrency?: any
  c_arcpurchasecost?: any
  c_arcqualificationseveryxmonths?: any
  c_arcqualityapprover?: any
  c_arcqualityapprover_data?: any
  c_arcreplacementcost?: any
  c_arcreplacementdate?: any
  c_arcroomspace?: any
  c_arcserialnumber?: any
  c_arcsystem?: any
  c_assetadded?: any
  c_assetclass?: any
  c_assetdeconrisk?: any
  c_assetdescription?: any
  c_assetlookup?: any
  c_assettype?: any
  c_availablestatus?: any
  c_backuplabmanager?: any
  c_biologicalcontaminationrisk?: any
  c_budget?: any
  c_building?: any
  c_buildingname?: any
  c_calibrationseveryxmonths?: any
  c_chemicalcontaminationrisk?: any
  c_clientcostcenter?: any
  c_clientcriticalitylevel?: any
  c_clientfinanceid?: any
  c_compid?: any
  c_contaminationassessment?: any
  c_contaminationrisk?: any
  c_contaminationriskb?: any
  c_contaminationriskc?: any
  c_controlmeasures?: any
  c_deconmethod?: any
  c_department?: any
  c_department_data?: any
  c_detaileddescription?: any
  c_documenta?: any
  c_documentb?: any
  c_documentc?: any
  c_email?: any
  c_floorlevel?: any
  c_freearcmanufacturer?: any
  c_freearcmodel?: any
  c_gxpstatus?: any
  c_gxpstatus_data?: any
  c_imagefield?: any
  c_instrumentowner?: any
  c_instrumentworkingstatus?: any
  c_istherearisktouserpatientorcriticalprocess?: any
  c_kpienabled?: any
  c_labmanager?: any
  c_locationadditionaldetails?: any
  c_manufacturer?: any
  c_model?: any
  c_modelnumber?: any
  c_neededbydate?: any
  c_nextcalibrationdate?: any
  c_nextcertificationdate?: any
  c_nextpmdate?: any
  c_nextqualificationdate?: any
  c_numberofcalibrations_data?: any
  c_numberofpms_data?: any
  c_numberofqualifications_data?: any
  c_numberofrepairs_data?: any
  c_pmseveryxmonths?: any
  c_problemtype?: any
  c_qualificationseveryxmonths?: any
  c_radioactivitycontaminationrisk?: any
  c_relatedwo?: any
  c_requestedon?: any
  c_requesteremail?: any
  c_requesterphone?: any
  c_requesttype?: any
  c_residualcontamination?: any
  c_roomspace?: any
  c_serialnumber?: any
  c_serviceprovider?: any
  c_site?: any
  c_system?: any
  c_system_data?: any
  c_timedateofapproval?: any
  c_triage?: any
  c_workordertype?: any
  c_workordertype_data?: any
  c_workphone?: any
  c_workservicegroup?: any
  description?: any
  details?: any
  formId?: any
  comments?: any
  image?: any
  number?: any
  rejectionReason?: any
  requestedBy?: any
  requestedBy_data?: any
  site?: any
  status?: any
  createdBySource?: any
  createdBySource_data?: any
  createdBy?: any
  createdOnSource?: any
  createdOn?: any
  updatedBySource?: any
  updatedBySource_data?: any
  updatedBy?: any
  updatedOnSource?: any
  updatedSyncDateSource?: any
  updatedOn?: any
  isDeleted?: any
  enabled?: any
  workrequest_timeline_status?: string
  wr_system_name?: string
  wr_cc_name?: string
  wo_cc_name?: string
  c_scheduleddateandtime?: any
  primaryassignment_fullname?: any
  primaryassignment_company?: any
  c_serviceprovider_data?: any
  c_arcbackuplabmanager_data?: any
  c_clientcriticalitylevel_data?: any
  c_currentserviceprovider?: any
  c_wr_arcclientcostcenter_name?: any
  ins_wo_cc_name?: any
  ins_wr_cc_name?: any
  wr_arc_system_name?: any
  wo_system_name?: any
  c_instrumentowner_data?: any
  c_backupinstrumentowner_data?: any
  c_labmanager_data?: any
  c_backuplabmanager_data?: any
  request_td_clientcriticalitylevel?: any
  request_td_clientbusinessimpact?: any
  workOrderIdSource?: any
  workOrderId?: any
  wo_number?: any
  wr_number?: any
  wr_group?: any;
  c_exceptionjustification?: any;
  c_entitlementexceptionreason?: any;
  c_requestexception?: any;
  request_td_repairs?: any;
  request_td_cleaningdate?: any;
  request_td_cleanings?: any;
  request_td_calibrationdate?: any;
  request_td_calibrations?: any;
  request_td_certificationdate?: any;
  request_td_certifications?: any;
  request_td_qualificationdate?: any;
  request_td_qualifications?: any;
  request_td_pmdate?: any;
  request_td_pms?: any;
  request_td_site?: any;
  request_td_serialnumber?: any;
  request_td_modelnumber?: any;
  request_td_manufacturer?: any;
  request_td_budget?: any;
  request_td_clientfinancialid?: any;
  request_td_clientcostcenter?: any;
  request_td_purchasecost?: any;
  request_td_purchasecurrency?: any;
  request_td_installdate?: any;
  request_td_endofwarrantydate?: any;
  request_td_serviceprovider?: any;
  request_td_gxpstatus?: any;
  request_td_assetdescription?: any;
  request_td_instrumentowner?: any;
  request_td_labmanager?: any;
  request_td_backuplabmanager?: any;
  request_td_buildingname?: any;
  request_td_floorlevel?: any;
  request_td_roomspace?: any;
  request_td_department?: any;
  request_td_financialapprover?: any;
  request_td_qualityapprover?: any;
  request_td_entitlementexceptionreason?: any;
  documentid?: string;
  documentId?: string;
  internaldocumentid?: string;
  c_istherearisktouserpatientorcriticalprocess_data?: any;
  c_instrumentworkingstatus_data?: any;
  request_internaldocumentid?: any;
  wo_supplier_confirmation_no?: any;

}

interface Props {
  requestData: RequestDetails;
  loading?: boolean
}

const CustomData = (val: React.ReactNode, val2?: React.ReactNode) => {
  val = val && typeof val === "object" ? JSON.stringify(val) : val;
  val2 = val2 && typeof val2 === "object" ? JSON.stringify(val2) : val2;
  val = moment(val as string, moment.ISO_8601, true).isValid() ? customFormatDate(val as string, false) : val;
  val2 = moment(val2 as string, moment.ISO_8601, true).isValid() ? customFormatDate(val2 as string, false) : val2;
  return <div><div className="d-flex align-items-center">
    <Box
      sx={{
        padding: "2px 8px",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 1,
        bgcolor: '#FBEEEE',
        marginBottom: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block",
        whiteSpace: "nowrap",
        textDecoration: val ? "line-through" : "",
        minHeight: "1rem"
      }}
    >{val ? val : <span className='empty-value'>Empty</span>}
    </Box>
  </div>
    {
      <div className="d-flex align-items-center">

        <Box
          sx={{
            padding: "2px 8px",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 1,
            bgcolor: '#E6F4EC',
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "block",
            whiteSpace: "nowrap",
            minHeight: "1rem"

          }}
        >{val2 ? val2 : <span className='empty-value'>Empty</span>}
        </Box>
      </div>
    }
  </div>
}

const RequestDetailInfo: React.FC<Props> = ({
  requestData,
  loading
}) => {

  const renderValues = (key: string, apiData = '') => {
    return modifiedInfo[key] ? CustomData(modifiedInfo[key].prev, modifiedInfo[key].next) : null;
  }
  const [systemData, setSystemData] = useState<any[]>([]);
  const [workOrderAttachments, setWorkOrderAttachments] = useState<any[]>([]);
  const [approvalQuoteAttachments, setApprovalQuoteAttachments] = useState<any[]>([]);
  const [attachmentsLoading, setAttachmentsLoading] = useState(false);
  const systemUrl = useSelector(getSystemDetailUrl);
  const [instrumentLoading, setInstrumentLoading] = useState(false);
  const [instrumentData, setInstrumentData] = useState<any>({});
  const instrumentDetailUrl = useSelector(getInstrumentDetailUrl);
  const baseUrl = useSelector(
    (state: any) => state?.config?.client?.flowApiUrl,
  );
  const reqBaseUrl = useSelector(getRequestbaseUrl);
  const history = useHistory();

  // Function to handle instrument selection
  const handleInstrumentSelect = (assetId: string) => {
    history.push(`/elis/instruments/details/${assetId}`);
  };

  // Handle attachment download
  const handleDownloadAttachment = async (doc: any) => {
    if (!doc?.c_wodocument) {
      console.error('❌ c_wodocument is missing in document:', doc);
      return;
    }
    
    if (!requestData?.workOrderId) {
      console.error('❌ workOrderId is undefined');
      return;
    }
    
    try {
      // Extract filename from c_wodocument path (everything after 'blobs/')
      const fileName = doc.c_wodocument.split('/blobs/').pop() || doc.c_wodocument.split('/').pop();
      
      // Use the Document Management API
      const apiUrl = `${reqBaseUrl.replace(/\/$/, '')}/documents/work-order/download`;
      
      // Use the service's raw axios instance for file download
      const response = await (service as any).service.request({
        method: 'POST',
        url: `${apiUrl}${requestData?.site ? `?site=${requestData.site}` : ''}`,
        responseType: 'blob',
        data: { 
          workOrderId: parseInt(requestData?.workOrderId),
          documentPath: doc.c_wodocument, // Complete path from eMaint
          fileName: fileName // Extracted filename for download
        }
      });
      
      // Create download link with proper filename
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  // Fetch system data when the component loads
  React.useEffect(() => {
    if (!requestData?.c_system) return;

    service.get(`${systemUrl}?fetchAll=true&pageNumber=1&pageSize=20&systemId=${encodeURIComponent(requestData.c_system)}&assetId=${encodeURIComponent(requestData.assetId || '')}`).then((res) => {
      if (res.data?.recordsList) {
        setSystemData(res.data.recordsList || []);
      }
    });
  }, [requestData?.c_system, systemUrl, requestData?.assetId]);

  // Fetch work order attachments when requestData is available
  useEffect(() => {
    const fetchAttachments = async () => {
      // Only fetch if we have a valid workOrderIdSource (not null, not undefined, not empty)
      if (!requestData?.workOrderIdSource || requestData.workOrderIdSource === null || loading) {
        setWorkOrderAttachments([]);
        setApprovalQuoteAttachments([]);
        return;
      }
      
      setAttachmentsLoading(true);
      try {
        const response = await service.get(
          `${reqBaseUrl.replace(/\/$/, '')}/work-requests/work-order/attachments?workOrderIdSource=${requestData.workOrderIdSource}${requestData.site ? `&site=${requestData.site}` : ''}`
        );
        if (response.data?.attachments) {
          setWorkOrderAttachments(response.data.attachments);
        }
        if (response.data?.approvalQuote) {
          setApprovalQuoteAttachments(response.data.approvalQuote);
        }
      } catch (error) {
        console.error('Failed to fetch work order attachments:', error);
      } finally {
        setAttachmentsLoading(false);
      }
    };

    fetchAttachments();
  }, [requestData?.workOrderIdSource, requestData?.site, reqBaseUrl, loading]);

  const modifiedInfo = (requestData as { previousinstrumentdata: { [key: string]: { prev: any, next: any } } })?.previousinstrumentdata || {}

  const isItHasWorkOrder = requestData?.workOrderIdSource || requestData?.wo_number;

  const requestType = requestData?.c_requesttype || '';

  const RenderBasedOnRequestType = () => {
    if (requestType?.toLowerCase()?.includes("add")) {
      return renderAddRequestType();
    }

    if (requestType?.toLowerCase()?.includes("change")) {
      return renderChangeRequestType();
    }
    if (requestType?.toLowerCase()?.includes("remove")) {
      return renderRemoveRequestType();
    }
    if (requestData?.c_controlmeasures) {
      return renderWORequestType();
    }
    // Fallback: if we have a work order but no recognized request type, still show work order details
    if (isItHasWorkOrder) {
      return renderWorkOrderSection();
    }
    return renderDefaultRequestType();
  }

  const renderWorkOrderSection = () => {
    return (
      <div className={'section-item'}>
        <h2 className="sectionTitle">Work Order</h2>
        <div className="detailItem">
          <span className="detailLabel">Work Order ID</span>
          <span className="detailValue">
            {requestData?.wo_number || '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Type of request</span>
          <span className="detailValue">
            {requestData?.c_workordertype_data?.title || '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">
            Service provider
          </span>
          <span className="detailValue">
            {requestData?.request_td_serviceprovider || '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">
            Supplier confirmation number
          </span>
          <span className="detailValue">
            {requestData?.wo_supplier_confirmation_no || '--'}
          </span>
        </div>


        <div className="detailItem">
          <span className="detailLabel">Requested by</span>
          <span className="detailValue">
            {requestData?.requestedBy_data?.title || '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Created on</span>
          <span className="detailValue">
            {requestData?.createdOn ? moment(requestData.createdOn).format('MMM DD, YYYY h:mm a') || '--' : '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Completed on</span>
          <span className="detailValue">
            {(requestData as any)?.c_completedon ? moment((requestData as any).c_completedon).format('MMM DD, YYYY h:mm a') || '--' : '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">
            Brief description
          </span>
          <span className="detailValue">
            {requestData?.description || '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Work order attachments</span>
          <span className="detailValue">
            {attachmentsLoading ? (
              <Skeleton variant="text" width="200px" height={20} />
            ) : [...workOrderAttachments, ...approvalQuoteAttachments].length > 0 ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {[...workOrderAttachments, ...approvalQuoteAttachments].map((attachment: any, index: number) => (
                  <Box 
                    key={index}
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 1,
                      cursor: 'pointer',
                      color: '#0066CC',
                      '&:hover': {
                        opacity: 0.7,
                        textDecoration: 'underline'
                      }
                    }}
                    onClick={() => handleDownloadAttachment({ c_wodocument: attachment.documentPath })}
                  >
                    <DescriptionIcon sx={{ fontSize: 18 }} />
                    <span>{attachment.fileName}</span>
                  </Box>
                ))}
              </Box>
            ) : (
              '--'
            )}
          </span>
        </div>
        <div className="detailItem full-width">
          <span className="detailLabel">
            Work order details
          </span>
          <div className="work-order-details detailValue">
            <span
              className="detailValue"
              dangerouslySetInnerHTML={{
                __html: xss(requestData?.details || '--'),
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderDefaultRequestType = () => {
    return (<>
      <div className={'section-item'}>
        <h2 className="sectionTitle">Request</h2>

        <div className="detailItem">
          <span className="detailLabel">Request group</span>
          {/* <span className="detailValue">{requestData?.wr_group || '--'}</span> */}
          <div className="detailValue">
            {requestData?.requestId && requestData?.wr_group ? (
              <RequestGroupDropdown
                requestId={requestData?.requestId}
                groupId={requestData?.wr_group}
                currentRequestId={requestData?.requestId}
                requestGroupFormatted={`${requestData?.wr_group ? 'RG ' + requestData?.wr_group : '--'}`}
                onRequestSelect={(requestId) =>
                  history.push(
                    `/elis/requests/details/${requestId}`,
                  )
                }
              />
            ) : (
              '--'
            )}
          </div>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Type of request</span>
          <span className="detailValue">
            {requestType}
          </span>
        </div>
        {requestData?.description && (
          <div className="detailItem">
            <span className="detailLabel">Description</span>
            <span className="detailValue">
              {requestData?.description || '--'}
            </span>
          </div>
        )}
        <div className="detailItem">
          <span className="detailLabel">Requested by</span>
          <span className="detailValue">
            {requestData?.requestedBy_data?.title || '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Creation date</span>
          <span className="detailValue">
            {requestData?.createdOn ? moment(requestData.createdOn).format('MMM DD, YYYY h:mm a') || '--' : '--'}
          </span>
        </div>
      </div>
    </>)
  }

  const renderAddRequestType = () => {
    return (<>
      <div className={'section-item'}>
        <h2 className="sectionTitle">Request</h2>

        <div className="detailItem">
          <span className="detailLabel">Request group</span>
          {/* <span className="detailValue">{requestData?.wr_group || '--'}</span> */}
          <div className="detailValue">
            {requestData?.requestId && requestData?.wr_group ? (
              <RequestGroupDropdown
                requestId={requestData?.requestId}
                groupId={requestData?.wr_group}
                currentRequestId={requestData?.requestId}
                requestGroupFormatted={`${requestData?.wr_group ? 'RG ' + requestData?.wr_group : '--'}`}
                onRequestSelect={(requestId) =>
                  history.push(
                    `/elis/requests/details/${requestId}`,
                  )
                }
              />
            ) : (
              '--'
            )}
          </div>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Type of request</span>
          <span className="detailValue">
            {requestType?.toLowerCase()?.includes("add") ? 'Add' : requestType?.toLowerCase()?.includes("remove") ? 'Remove instrument' : 'Change instrument'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Requested by</span>
          <span className="detailValue">
            {requestData?.requestedBy_data?.title || '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Creation date</span>
          <span className="detailValue">
            {requestData?.createdOn ? moment(requestData.createdOn).format('MMM DD, YYYY h:mm a') || '--' : '--'}
          </span>
        </div>

        <div className={'detailItem rm-border'}>
          <span className="detailLabel">Request attachments</span>
          {(requestData?.request_internaldocumentid || requestData?.internaldocumentid || requestData?.documentId) ? <div className='detailValue'>
            <Box className="section-content">
              <DocumentsContainer
                baseUrl={baseUrl}
                documentId={requestData?.request_internaldocumentid || requestData?.internaldocumentid || requestData?.documentId}
                hideUpload
                hideDelete
              />
            </Box>
          </div> : <span className="detailValue">--</span>}
        </div>
      </div>
      {isItHasWorkOrder && renderWorkOrderSection()}
    </>)
  }

  const renderChangeRequestType = () => {
    const summaryChanges = Object.keys(modifiedInfo).length > 0;
    const labelMapping: { [key: string]: string } = {
      system: 'System',
      instrumentDescription: 'Instrument description',
      instrumentOwner: 'Instrument owner',
      labManager: 'Lab manager',
      financialApprover: 'Financial approver',
      backupLabManager: 'Backup lab manager',
      qualityApprover: 'Quality approver',
      gxpStatus: 'GXP status',
      businessCriticality: 'Business criticality',
      localDesignation: 'Local designation',
      manufacturer: 'Manufacturer',
      modelNumber: 'Model',
      serialNumber: 'Serial number',
      assetType: 'Instrument type',
      assetClass: 'Instrument class',
      site: 'Site',
      building: 'Building',
      floorLevel: 'Floor',
      roomSpace: 'Room',
      department: 'Department',
      pms: '(PM) Planned Maintenances',
      pmsDate: 'PM date',
      qualifications: 'Qualifications',
      qualificationsDate: 'Qualifications date',
      certifications: 'Certifications',
      certificationsDate: 'Certifications date',
      calibrations: 'Calibration',
      calibrationsDate: 'Calibration date',
      cleanings: 'Cleaning',
      cleaningsDate: 'Cleaning date',
      repairs: 'Repairs',
      serviceProvider: 'Service provider',
      endOfWarrantyDate: 'End of warranty date',
      installDate: 'Install date',
      costCenterDisplayName: 'Cost Center Name',
      costCenter: 'Cost Center',
      financialId: 'Financial ID',
      purchaseCost: 'Purchase cost',
      purchaseCurrency: 'Purchase currency',
      exceptionReason: 'Exception reason',
      exceptionDetails: 'Exception details',
      


    };
    return (<>
      {renderAddRequestType()}

      {summaryChanges && <div className={'section-item'}>
        <h2 className="sectionTitle">Summary of changes</h2>

        {Object.keys(modifiedInfo).map((key) => {
          return (
            <div className="detailItem" key={key}>
              <span className="detailLabel">{labelMapping[key] || key}</span>
              <span className="detailValue">
                {CustomData(modifiedInfo[key].prev, modifiedInfo[key].next)}
              </span>
            </div>
          )
        })}

      </div>}
    </>)
  }

  const renderRemoveRequestType = () => {
    return (<>
      {renderAddRequestType()}
    </>)
  }

  const renderWORequestType = () => {
    return (<>
      {requestData?.wr_number && <div className={'section-item'}>
        <h2 className="sectionTitle">Request</h2>
        <div className="detailItem">
          <span className="detailLabel">Type of request</span>
          <span className="detailValue">
            {requestData?.c_requesttype || '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Requested by</span>
          <span className="detailValue">
            {requestData?.requestedBy_data?.title || '--'}
          </span>
        </div>

        <div className="detailItem">
          <span className="detailLabel">Created on</span>
          <span className="detailValue">
            {requestData?.createdOn ? moment(requestData.createdOn).format('MMM DD, YYYY h:mm a') || '--' : '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Is there a risk to user/product of critical process? </span>
          <span className="detailValue">
            {requestData?.c_istherearisktouserpatientorcriticalprocess_data?.title || '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Instrument working status </span>
          <span className="detailValue">
            {requestData?.c_instrumentworkingstatus_data?.title || '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Brief description </span>
          <span className="detailValue">
            {requestData?.description || '--'}
          </span>
        </div>
       
        <div className={'detailItem rm-border'}>
          <span className="detailLabel">Request attachments</span>
          {(requestData?.request_internaldocumentid || requestData?.internaldocumentid || requestData?.documentId) ? <div className='detailValue'>
            <Box className="section-content">
              <DocumentsContainer
                baseUrl={baseUrl}
                documentId={requestData?.request_internaldocumentid || requestData?.internaldocumentid || requestData?.documentId}
                hideUpload
                hideDelete
              />
            </Box>
          </div>
            : <span className="detailValue">--</span>}
        </div>

        <h2 className='sectionTitle ml-3 mt-2' style={{ paddingTop: '12px', borderTop: '1px solid rgba(0, 63, 45, 0.15)', borderRadius: 0, fontSize: 16 }}>Contamination assessment</h2>
        <div className="detailItem">
          <span className="detailLabel">Is there a hazard present</span>
          <span className="detailValue">
            {[
              requestData?.c_biologicalcontaminationrisk == "true" ? true : '',
              requestData?.c_chemicalcontaminationrisk == "true" ? true : '',
              requestData?.c_radioactivitycontaminationrisk == "true" ? true : ''
            ].filter(Boolean).length ? 'Yes' : 'No'}
          </span>
        </div>

        <div className="detailItem">
          <span className="detailLabel">Hazard type</span>
          <span className="detailValue">
            {[
              requestData?.c_biologicalcontaminationrisk == "true" ? 'Biological' : '',
              requestData?.c_chemicalcontaminationrisk == "true" ? 'Chemicals' : '',
              requestData?.c_radioactivitycontaminationrisk == "true" ? 'Radioactivity' : ''
            ].filter(Boolean).join(', ') || '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Control measures</span>
          <span className="detailValue">
            {requestData?.c_controlmeasures || '--'}
          </span>
        </div>
        <div className="detailItem">
          <span className="detailLabel">Describe the method(s) of decontamination</span>
          <span className="detailValue">
            {requestData?.c_deconmethod || '--'}
          </span>
        </div>

      </div>}

      {isItHasWorkOrder && renderWorkOrderSection()}
    </>)
  }

  const isAddRequest = requestType?.toLowerCase()?.includes("add");

  useEffect(() => {
    if (requestData?.assetId && !isAddRequest) {
      setInstrumentLoading(true)
      service.get(`${instrumentDetailUrl}${requestData?.assetId}`).then(({ data = {} }) => {
        setInstrumentData(data);
      }).finally(() => {
        setInstrumentLoading(false);
      })
    }
  }, [requestData?.requestId, isAddRequest, requestData?.number]);

  return (
    <div className='d-flex' style={{ gap: 16, height: '100%' }}>

      <div className="request-details-info">
        <div className="wrapper">
          <main className="content">
            <section className="main">
              <article>
                <section className="section">
                  {loading ? (
                    <>
                      <Skeleton />
                      <Skeleton width="60%" />
                      <Skeleton variant="rectangular" width="60%"></Skeleton>
                    </>
                  ) : (
                    <div className={'section-container'}>

                      <div className={'section-1'}>
                        {RenderBasedOnRequestType()}
                      </div>
                    </div>
                  )}
                </section>
              </article>
            </section>
          </main>
        </div>
      </div>
      <div className="instrument-details-panel" style={{ width: 360 }}>
        <div className="wrapper">
          <main className="content">
            <section className="main">
              <article>
                <section className="section">
                  {instrumentLoading ? (
                    <>
                    <div className={'section-container'}>
                      <div className={'section-1'}>
                        <div className={'section-item full-width'}>
                          <h2 className="sectionTitle mb-1"><Skeleton width="60%" /></h2>
                          <p className='detailLabel mb-1'><Skeleton width="40%" /></p>
                          <div>
                            <div className="detailItem">
                              <span className="detailLabel">
                                <Skeleton width="80px" />
                              </span>
                              <span className="detailValue">
                                <Skeleton width="120px" />
                              </span>
                            </div>
                            <div className="detailItem">
                              <span className="detailLabel">
                                <Skeleton width="80px" />
                              </span>
                              <span className="detailValue">
                                <Skeleton width="120px" />
                              </span>
                            </div>
                            <div className="detailItem">
                              <span className="detailLabel">
                                <Skeleton width="80px" />
                              </span>
                              <span className="detailValue">
                                <Skeleton width="120px" />
                              </span>
                            </div>
                            <div className="detailItem">
                              <span className="detailLabel">
                                <Skeleton width="80px" />
                              </span>
                              <span className="detailValue">
                                <Skeleton width="120px" />
                              </span>
                            </div>
                            <div className="detailItem">
                              <span className="detailLabel">
                                <Skeleton width="80px" />
                              </span>
                              <span className="detailValue">
                                <Skeleton width="120px" />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                      <Skeleton />
                      <Skeleton width="60%" />
                      <Skeleton variant="rectangular" width="60%"></Skeleton>
                    </>
                  ) : (
                    <div className={'section-container'}>
                      <div className={'section-1'}>
                        <div className={'section-item full-width'}>
                          <h2 className="sectionTitle mb-1">Instrument details</h2>
                          {!requestType?.toLowerCase()?.includes("add") && <p className='detailLabel mb-1'> {requestData?.createdOn ? `As of ${moment(requestData.createdOn).format('MMM DD, YYYY h:mm a')}` : '--'}</p>}
                          <div>
                            <div className="detailItem">
                              <span className="detailLabel">
                                instrument ID
                              </span>
                              {requestData?.c_compid ? <span className="detailValue">
                                <Link to={`/elis/instruments/details/${requestData?.assetId}`}>{requestData?.c_compid || '--'}</Link>
                              </span> : <span className="detailValue">--</span>}
                            </div>
                            <div className="detailItem">
                              <span className="detailLabel">
                                system
                              </span>
                              <span className="detailValue">
                                {requestData?.assetId && (requestData?.c_compid) ? (
                                  <SystemDropdown
                                    systemName={requestData?.request_td_system || requestData?.c_compid}
                                    systemData={systemData}
                                    currentAssetId={requestData?.assetId}
                                    onInstrumentSelect={handleInstrumentSelect}
                                  />
                                ) : (
                                  requestData?.wr_arc_system_name || '--'
                                )}
                              </span>
                            </div>

                            <div className="detailItem">
                              <span className="detailLabel">
                                Manufacturer
                              </span>
                              <span className="detailValue">
                                {isAddRequest ? requestData?.request_td_manufacturer || '--' : instrumentData?.c_manufacturer || '--'}
                              </span>
                            </div>
                            <div className="detailItem">
                              <span className="detailLabel">
                                Model
                              </span>
                              <span className="detailValue">
                                {isAddRequest ? requestData?.request_td_modelnumber || '--' : instrumentData?.c_modelnumber || '--'}
                              </span>
                            </div>

                            <div className="detailItem">
                              <span className="detailLabel">
                                Serial number
                              </span>
                              <span className="detailValue">
                                {isAddRequest ? requestData?.request_td_serialnumber || '--' : instrumentData?.c_serialnumber || '--'}
                              </span>
                            </div>
                            <div className="detailItem">
                              <span className="detailLabel">
                                Instrument owner
                              </span>
                              <span className="detailValue">
                                {isAddRequest ? requestData?.request_td_instrumentowner || '--' : instrumentData?.c_instrumentowner_data?.title || '--'}
                              </span>
                            </div>


                            <div className="detailItem">
                              <span className="detailLabel">
                                Department
                              </span>
                              <span className="detailValue">
                                {isAddRequest ? requestData?.request_td_department || '--' : instrumentData?.c_department_data?.title || '--'}
                              </span>
                            </div>
                            <div className="detailItem">
                              <span className="detailLabel">
                                Site
                              </span>
                              <span className="detailValue">
                                {isAddRequest ? requestData?.request_td_site || '--' : (instrumentData as { sites?: any })?.sites?.siteName || '--'}
                              </span>
                            </div>

                            <div className="detailItem">
                              <span className="detailLabel">
                                Building
                              </span>
                              <span className="detailValue">
                                {isAddRequest ? requestData?.request_td_buildingname || '--' : instrumentData?.c_buildingname || '--'}
                              </span>
                            </div>
                            <div className="detailItem">
                              <span className="detailLabel">
                                Room
                              </span>
                              <span className="detailValue">
                                {isAddRequest ? requestData?.request_td_roomspace || '--' : instrumentData?.c_roomspace || '--'}
                              </span>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </section>
              </article>
            </section>
          </main>

        </div>
      </div>
    </div>
  );
};

export default RequestDetailInfo;